import { axios } from '@/services/axios';

export const deleteCountry = (countryId) => {
    return axios.delete(`/country/${countryId}`);
};
